var lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
		Vegas.cards();

		let $sale_tabs_item = $('.vg-catalog').find('.nav-tabs .nav-link');
		if ($sale_tabs_item.length) {
			$sale_tabs_item.each(function () {
				Vegas.fitTabs($(this), false);
			});
		}
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
		Vegas.auth();

		$('.vg-catalog').find('.nav-tabs .nav-link').click(function () {
			Vegas.fitTabs($(this));
			return true;
		});
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},

	onResize: () => {
		let $sale_tabs_item = $('.vg-catalog').find('.nav-tabs .nav-link');
		if ($sale_tabs_item.length) {
			$sale_tabs_item.each(function () {
				Vegas.fitTabs($(this), false);
			});
		}
	}
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// vg nav
		$('.vg-nav').vegasMenu();

		// nice select
		$('.nice-select').niceSelect();

		// tooltip
		$('[data-toggle="tooltip"]').tooltip();

		// Input mask
		this.enablePlugins_Inputmask();
	},
	enablePlugins_Inputmask: function(elements) {
		let $input_mask = elements || $('[data-mask]');
		console.log($input_mask)

		if ($input_mask) {
			$input_mask.each(function () {
				let $self = $(this);

				let mask, data = $self.data('mask');

				let params = {
					showMaskOnFocus: true,
					showMaskOnHover: false,
				};

				if (data === 'card-barcode') {
					mask = '9999999999999';
				}

				if (data === 'card-number') {
					mask = '999999';
				}

				if (data === 'phone') {
					mask = '+79999999999';
				}

				$self.inputmask(mask, params);
			});
		}
	},

	popup: function () {
		$('[data-modal]').click(function () {
			let $target = $(this).data('modal'),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false;

			if(title) {
				$($target).find('.modal-title').text(title);
			}

			if(id) {
				$($target).find('form input[name=id]').val(id);
			}

			$($target).modal('show');

			return false;
		});

		$('#modal-qr-reader').on('hide.bs.modal', function (e) {
			location.reload();
		})
	},

	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';

				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},

	carousel: function () {
		OwlVegas.init('owl-carousel');
	},

	other: function () {
		// default page
		let $pageText = $('.page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		//$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');

		$('.form-group__eye').click(function () {
			let $self = $(this),
				$input = $self.closest('.form-group').find('input'),
				$icon = $self.find('i');

			if ($icon.hasClass('fa-eye-slash')) {
				$icon.removeClass('fa-eye-slash').addClass('fa-eye');
				$input.attr('type', 'text')
			} else {
				$icon.removeClass('fa-eye').addClass('fa-eye-slash');
				$input.attr('type', 'password')
			}

			return false;
		});

		let $blogOwl = $('.vg-blog').find('.owl-carousel'),
			blogStageHeight = $blogOwl.find('.owl-stage').height();

		$blogOwl.find('.vg-blog-item').css('height', blogStageHeight);

		$('input.ucfirst').keyup(function () {
			let val = $(this).val();
			val = val.substr(0, 1).toUpperCase() + val.substr(1).toLowerCase();
			$(this).val(val);
		});
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-hdr-fixed'),
			scroll = $self.scrollTop(),
			scroll_hide = 65;

		if (scroll > 130) {
			$body.addClass('vg-hdr--is-scroll');

			if (scroll > lastScrollTop) {
				$sticky.css('top', -scroll_hide);
				$body.removeClass('vg-hdr--is-fixed');
			} else {
				$sticky.css('top', 0);
				$body.addClass('vg-hdr--is-fixed');
			}

			lastScrollTop = scroll;

		} else {
			$sticky.css('top', -scroll_hide);
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}

		let $catalog_sticky = $('.vg-catalog-sticky');
		if ($catalog_sticky.length) {
			if ($body.hasClass('vg-hdr--is-fixed')) {
				$catalog_sticky.css('top', 75)
			} else {
				$catalog_sticky.css('top', 10)
			}
		}
	},

	auth: function () {
		let $form = $('[data-form]'),
			$toggle = $('[data-toggle=user-form]');

		$toggle.on('click', function () {
			let $self = $(this),
				target = $self.data('target');

			$form.hide();
			$('[data-form='+ target +']').show();

			return false;
		});

		let $vg_form = $('.vg-form'),
			$inputs = $vg_form.find('input, textarea');

		$inputs.each(function () {
			let $self = $(this),
				required = $(this).attr('required');

			if (typeof required !== typeof undefined && required !== false) {
				$self.closest('.form-group').find('label').append('<span class="required"><i class="fal fa-asterisk"></i></span>')
			}
		});

		$vg_form.submit(function () {
			let $password = $(this).find('input[name=pass]') || $(this).find('input[name=new_pass]'),
				$re_password = $(this).find('input[name=re_pass]');

			$('.form-group__alert').hide();

			if ($password.length && $re_password.length) {
				let pass = $password.val(),
					re_pass =  $re_password.val();

				if (pass !== re_pass) {
					$password.closest('.form-group').find('.form-group__alert').show();
					$re_password.closest('.form-group').find('.form-group__alert').show();

					return false;
				}
			}

			return true;
		});
	},

	cards: function () {
		let $cardNumber = $('.card-number');

		if ($cardNumber.length) {
			let number = $cardNumber.data('number');

			/*function splitByIndex(value, index, reverse = false) {
				if (value.length <= index) {
					return value;
				} else {
					let regex = new RegExp('(.{1,'+ index +'})', 'gim');
					let arr = value.match(regex) || '';

					if (reverse) {
						arr.reverse()
					}

					return arr;
				}
			}

			let result  = splitByIndex(number, 4), str = '';

			for (let i = 1; i <= result.length; i++) {
				str += '<span>' + result[i - 1] + '</span>'
			}*/

			$cardNumber.html(number);

		}
	},

	fitTabs: function ($self, click = true) {
		let items = parseInt($self.data('items')),
			mdItems = parseInt($self.data('md')),
			lgItems = parseInt($self.data('lg')),
			xlItems = parseInt($self.data('xl'));

		if (click || $self.hasClass('active')) {
			if (window.innerWidth >= 768 && window.innerWidth <= 991.98) {
				if (items <= mdItems) {
					$self.closest('.nav-tabs').css('margin-right', 0);
				} else {
					$self.closest('.nav-tabs').css('margin-right', 130);
				}
			}

			if (window.innerWidth >= 992 && window.innerWidth <= 1199.98) {
				if (items <= lgItems) {
					$self.closest('.nav-tabs').css('margin-right', 0);
				} else {
					$self.closest('.nav-tabs').css('margin-right', 130);
				}
			}

			if (window.innerWidth >= 1200) {
				if (items <= xlItems) {
					$self.closest('.nav-tabs').css('margin-right', 0);
				} else {
					$self.closest('.nav-tabs').css('margin-right', 130);
				}
			}
		}
	}
};
